import { computeMediaHasFailed } from './normalizeMediaStatus';

export const mapPendingProjectImage = (pendingImage) => ({
  thumbnail: pendingImage.full,
  full: pendingImage.full,
  gallery: pendingImage.full,
  status: pendingImage.status,
  error: computeMediaHasFailed(pendingImage),
  image_id: pendingImage.image_id
});

const mapReadyProjectImage = (url) => ({
  thumbnail: url,
  full: url,
  gallery: url
});

const mergeProjectImages = (images = [], pendingImages = []) => [
  ...images.map(mapReadyProjectImage),
  ...pendingImages.map(mapPendingProjectImage)
];

export default mergeProjectImages;
